const env = process.env.NODE_ENV || 'development';
const route = {
  development: '',
  staging: 'https://web-static.linetv.tw/staging-fargate/public',
  production: 'https://web-static.linetv.tw/release-fargate/public',
};

module.exports = route[env];
